import _asyncToGenerator from "D:/hjj/bio_link_pc/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, withModifiers as _withModifiers, normalizeStyle as _normalizeStyle, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue";
import { ref, watch } from "vue";
import { ElMessage } from "element-plus";
export default {
  __name: 'blockPaste',
  props: {
    modelValue: {
      type: Boolean,
      default: false
    },
    position: {
      type: Object,
      default: () => ({
        x: 0,
        y: 0
      })
    },
    target: {
      type: Object,
      default: () => ({
        rowIndex: -1,
        prop: ""
      })
    }
  },
  emits: ["update:modelValue", "paste"],
  setup(__props, _ref) {
    var {
      emit: __emit
    } = _ref;
    var props = __props;
    var emit = __emit;
    var visible = ref(false);

    // 监听modelValue变化
    watch(() => props.modelValue, val => {
      visible.value = val;
      if (val) {
        // 添加全局点击事件监听器以隐藏菜单
        setTimeout(() => {
          document.addEventListener("click", hideContextMenu);
        }, 0);
      }
    });

    // 隐藏右键菜单
    var hideContextMenu = () => {
      visible.value = false;
      emit("update:modelValue", false);
      document.removeEventListener("click", hideContextMenu);
    };

    // 处理块粘贴
    var handleBlockPaste = /*#__PURE__*/function () {
      var _ref2 = _asyncToGenerator(function* () {
        try {
          // 读取剪贴板内容
          var text = yield navigator.clipboard.readText();
          if (text) {
            // 解析剪贴板数据
            var parsedData = parseClipboardData(text);
            if (parsedData.length > 0) {
              // 发送粘贴事件
              emit("paste", {
                data: parsedData,
                target: props.target
              });
            }
          } else {
            ElMessage.warning("剪贴板中没有内容");
          }
        } catch (err) {
          ElMessage.error("读取剪贴板失败，请手动粘贴");
        }

        // 隐藏菜单
        hideContextMenu();
      });
      return function handleBlockPaste() {
        return _ref2.apply(this, arguments);
      };
    }();

    // 解析剪贴板数据
    var parseClipboardData = data => {
      // 按行分割数据
      var rows = data.split("\n").filter(row => row.trim() !== "");

      // 解析每行的列数据
      return rows.map(row => {
        // 先按制表符分割（Excel默认分隔符）
        if (row.includes("\t")) {
          return row.split("\t");
        } else if (row.includes(",")) {
          // 按逗号分割
          return row.split(",").map(cell => cell.replace(/^"(.*)"$/, "$1").trim());
        } else {
          // 单列数据
          return [row.trim()];
        }
      });
    };

    // 处理键盘事件
    var handleKeyDown = event => {
      // ESC键隐藏菜单
      if (event.key === "Escape") {
        hideContextMenu();
      }
    };

    // 添加键盘事件监听
    document.addEventListener("keydown", handleKeyDown);
    return (_ctx, _cache) => {
      return visible.value ? (_openBlock(), _createElementBlock("div", {
        key: 0,
        class: "block-paste-context-menu",
        style: _normalizeStyle({
          left: __props.position.x + 'px',
          top: __props.position.y + 'px'
        }),
        onContextmenu: _cache[0] || (_cache[0] = _withModifiers(() => {}, ["prevent"]))
      }, [_createElementVNode("div", {
        class: "context-menu-item",
        onClick: handleBlockPaste
      }, _cache[1] || (_cache[1] = [_createElementVNode("span", {
        class: "iconfont icon-copy"
      }, null, -1), _createTextVNode(" 块粘贴 ")]))], 36)) : _createCommentVNode("", true);
    };
  }
};